export enum orbEnum {
  none = "none",
  green = "green",
  blue = "blue",
  purple = "purple",
  red = "red",
  gold = "gold",
}
